import { FieldSchemaFormBuilderV2, SchemaFactoryV2 } from "@ucl/library";
import { MODEL_KEYS, FIELD_KEYS } from "@/constants";
import { UnderwritingRuleResultUpdateDTO } from "@/types/UnderwritingRuleResultUpdateDTO";

export const createUnderwritingRuleResultFormBuilder = (
  schemaFactory: SchemaFactoryV2
): FieldSchemaFormBuilderV2<UnderwritingRuleResultUpdateDTO> => {
  return (onValueChange, form, errors) => {
    const fields = [
      ...schemaFactory.buildModelSchema<UnderwritingRuleResultUpdateDTO>(
        MODEL_KEYS.UNDERWRITING_RULE_RESULT,
        onValueChange,
        form,
        errors,
        [FIELD_KEYS.UNDERWRITING_RULE_RESULT.RESULT_TYPE], // Required fields
        {}
      ),
    ];

    return fields;
  };
};
